var map = {
	"./bounce/blocks": 2616,
	"./craft/agent/blocks": 2618,
	"./craft/code-connection/blocks": 2619,
	"./craft/designer/blocks": 2464,
	"./craft/simple/blocks": 2617,
	"./dance/blockly/blocks": 1885,
	"./flappy/blocks": 2621,
	"./jigsaw/blocks": 2627,
	"./maze/blocks": 2633,
	"./p5lab/spritelab/blocks": 1744,
	"./sites/studio/pages/blocks": 2648,
	"./studio/blocks": 2478,
	"./turtle/blocks": 2642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3148;